import type { PiletApi } from '@sharefiledev/sharefile-appshell';
import { addBlocks } from './Blocks';
import { AsyncLazyBlockDevelopment } from './Development';
import { setLogger } from './utils/logger/logger';

export function setup(app: PiletApi) {
	setLogger(app.sf.getLogger());
	addBlocks(app);
	if (process.env.NODE_ENV === 'development') {
		app.sf.registerLeftNavComponent({
			href: '/tasks-block-development',
			title: () => 'Tasks Page',
			icon: () => null,
		});

		app.registerPage('/tasks-block-development', () => (
			<AsyncLazyBlockDevelopment piletApi={app} />
		));
	}
}
